export default __webpack_public_path__ + "static/media/Petideal Creamy Salmon.88afe1fe.png";